const prod = {
  OIDC_AUTHORITY: "https://external-sso.wiley.com/auth/realms/wiley",
  OIDC_CLIENT_ID: "bcf56996-2033-4fc4-89dd-0fcaea2f4c5f",
  OIDC_CLIENT_SECRET: "8a13d786-bd45-46a3-8125-7b4e50ed7ed9",
  ALM_BASE_URL: "https://account.wiley.com",
  QAP_API_URL: "https://qap.wiley.host/prod",
  BYPASS_OIDC: false,
  DOMAIN: "qap.wiley.host",
  ENVIRONMENT: 'PROD',
  EQAT_REDIRECTION_URL: 'eqat://https@qap.wiley.com',
  EQAT_LAUNCH_URL: 'eqat://https@qap.wiley.host/prod',
  // AWS AppConfig
  APP_CONFIG_ENABLED: true,
};

export default prod;
